// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__7tH6W","modalFooterButton":"ModalNotes_modalFooterButton__3uQ0f"};